import React from "react";
import styles from "./FailureReportTable.module.css";

export type FailureReportRow = {
    zoneAddress: string;
    date: string;
    deviationReason?: string;
    contractor: string;
    vehicleNumber: string;
    collectionMethod: string;
};

type FailureReportProps = {
    data: FailureReportRow[];
};

const columns = [
    "Геозона/Адрес",
    "Дата смещения от графика",
    "Причина отклонения",
    "Подрядчик / организация",
    "Номер машины",
    "Способ сбора",
];

const FailureReportTable = ({ data }: FailureReportProps) => {
    const firstRow = data[0];

    return (
        <div className={styles.tableWrapper}>
            {firstRow && (
                <div className={styles.zoneHeader}>
                    <div className={styles.zoneTitle}>
                        Геозона / Адрес
                    </div>
                    <div className={styles.zoneMeta}>
                        {firstRow.zoneAddress}
                    </div>
                </div>
            )}

            <div className={styles.table}>
                <div className={styles.header}>
                    {columns.map(col => (
                        <div key={col} className={styles.th}>
                            {col}
                        </div>
                    ))}
                </div>

                <div className={styles.body}>
                    {data.length > 0 ? (
                        data.map((row, i) => (
                            <div key={i} className={styles.tr}>
                                <div
                                    className={`${styles.td} ${styles.dateCell}`}
                                >
                                    {row.date}
                                </div>
                                <div className={styles.td}>
                                    {row.deviationReason || "—"}
                                </div>
                                <div className={styles.td}>
                                    {row.contractor}
                                </div>
                                <div className={styles.td}>
                                    {row.vehicleNumber}
                                </div>
                                <div className={styles.td}>
                                    {row.collectionMethod}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className={styles.empty}>Нет данных</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FailureReportTable;


